import React, { Component, Fragment } from 'react';

import * as Func from '../../../../../../helpers/functions';
import { DATE_TIME_FORMAT, ORDER, PATHS } from '../../../../../../constants/Define';
import i18n from '../../../../../../constants/initLng';
import { getMomentDate } from '../../../../../../utils/commonUtils';
import {
    FormWrapperItem, ListComponent,
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import Span from "../../../../common/component/Span";
import * as HMS from "../../../../common/component/Index";
import { Skeleton, Modal, Menu, Icon, Dropdown, message, Input, Alert } from 'antd';
import Order, { OrderSurchargeItem } from '../../../../../../models/Order';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

// import './SurchargeInfo.less';

const OrderSurchargeItemKeys = Object.getOwnPropertyNames(new OrderSurchargeItem());
class SurchargeInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleOrderItemTable: Func.getTitleTable(['action', ...OrderSurchargeItemKeys], [], ['id', 'orderId', 'itemVariantId']),
            modelOrderItem: OrderSurchargeItemKeys,
            componentTable: {
                surchargeType: {
                    render: (text, record) => text && i18n.t(`item.order.surchargeType.${text}`)
                },
                paymentType: {
                    render: (text, record) => text && <HMS.StatusComponent color={'gray'}
                        label={i18n.t(`item.order.paymentTypes.${text}`)} />
                },
                paymentDate: {
                    render: (date) => date && getMomentDate(date).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                amount: {
                    key: 'amount',
                    render: (text, record) => Func.formatMoney(record.amount || '') + i18n.t('currencySymbol')
                },
                
                rateCodes: {
                    key: 'rateCodes',
                    render: (rateCodes, record) => rateCodes.map(rateCode => <p><Link to={Func.getPathWithParams(PATHS.RATECODE.DETAIL.path, { id: rateCode.id })} >{rateCode.code} | {rateCode.name}</Link></p>)
                },
                ftCode: {
                    key: 'ftCode',
                    render: (text, record) => text
                },
                isDeleted: {
                    key: 'isDeleted',
                    render: (isDeleted) => (
                        <HMS.StatusComponent color={!isDeleted ? 'green' : 'gray'}
                            label={!isDeleted ? this.props.t('item.surcharge.status.active') : this.props.t('item.surcharge.status.delete')} />
                    )
                },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            ftCode: '',
            isBackStock: false,
            itemSelected: null
        };
    }

    render() {
        const { surcharges, loading, orderId, t } = this.props;
        const { titleOrderItemTable, modelOrderItem, componentTable, itemSelected, ftCode, isBackStock } = this.state;
        return (
            <Wrapper className="surcharge-info-section col-md-12 mb-3">
                <h3 className={`ml-0`}>{i18n.t('item.order.surchargeInfo')}</h3>
                <Wrapper className={`row mt-2`}>
                    <FormWrapperItem classParent="p-0" classChildren="m-0 p-0">
                        {!loading ?
                            <ListComponent
                                classParent="m-0 p-0 col-md-12"
                                marginTop={'0'} marginBottom={'0'}
                                loading={{ spinning: loading, size: 'large' }}
                                rowKey={(record, k) => k}
                                dataSource={Func.getDataSource(surcharges || [], modelOrderItem)}
                                columns={Func.columnsTable({
                                    titleTable: titleOrderItemTable,
                                    component: componentTable,
                                    itemName: 'surcharge'
                                })}
                                componentTableList={{}}
                                hideSettings={true}
                            />
                            : <Skeleton active paragraph={{ row: 3 }} className="p-4" />
                        }
                    </FormWrapperItem>
                    <Modal 
                        title={t('item.surcharge.modalSurchage.title')} 
                        visible={!!itemSelected} 
                        onOk={this.confirmRemove} 
                        onCancel={this.handleCloseModal}
                        okText={t('action.confirm')}
                    >
                        {
                            !!itemSelected && 
                            <Fragment>
                                <p>Tổng tiền hủy phụ thu: <b>{Func.formatMoney(itemSelected.amount || '') + i18n.t('currencySymbol')}</b></p>
                                <HMS.FormWrapperInputComponent
                                    isRequired={true}
                                    isValidation={true}
                                    labelTitle={t(`item.surcharge.ftCode`)}
                                >
                                    <Input type="text"
                                        autoComplete="off"
                                        className="form-control" name="ftCode" onChange={(e) => this.setState({ ftCode: e.target.value })}
                                        value={ftCode} />

                                </HMS.FormWrapperInputComponent>
                                <HMS.CheckboxComponent className="mb-4" value={isBackStock} onChange={(e) => this.setState({ isBackStock: e.value })}>Back Stock</HMS.CheckboxComponent>
                                <Alert message={t('item.surcharge.modalSurchage.message')} type="info" showIcon />
                            </Fragment>
                        }
                    </Modal>
                </Wrapper>
            </Wrapper>
        );
    }

    confirmRemove = () => {
        if(!this.state.ftCode) {
            return message.error('Vui lòng nhập FT Code!')
        }
        const { itemSelected } = this.state
        itemSelected.ftCode = this.state.ftCode;
        itemSelected.isBackStock = this.state.isBackStock;
        this.props.removeSurcharge && this.props.removeSurcharge(itemSelected)
        this.handleCloseModal()
    }

    handleCloseModal = () => {
        this.setState({
            itemSelected: null,
            ftCode: ''
        })
    }

    renderEditComponent(item) {
        const { t } = this.props;
        const removeSurchargeDetail = () => {
            item.itemVariantId = item.itemVariantId
            item.listType = this.props.listType;
            this.setState({
                itemSelected: item
            })
            // this.props.removeSurcharge && this.props.removeSurcharge(item)
        }

        // const onClickOpenDetail = () => {
        //     this.props.openModalDetail(item.itemVariantId, item.id, this.props.listType)
        // }

        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {/* <Menu.Item onClick={onClickOpenDetail}><Icon type="form" className="fs20 mr-1" /> {i18n.t(`action.edit`)}</Menu.Item> */}
                        <Menu.Item onClick={removeSurchargeDetail}><Icon type="delete" className="fs20 mr-1" />{i18n.t(`action.remove`)}</Menu.Item>
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }
}

export default withTranslation()(SurchargeInfo)